<template>
  <div class="dropdown">
    <button :class="btnClass" type="button" data-toggle="dropdown">
      <i v-if="icon" class="icon-left" :class="icon"></i><span v-if="label">{{label}}: </span>{{selected}}
    </button>
    <div class="dropdown-menu is-custom" :class="rightMenu?'dropdown-menu-right':null">
      <div class="dropdown-menu__inner">
        <ul class="ul-list">
          <li v-for="item in options" :key="item.value" class="li-check" :class="inputVal===item.value?'active':null">
            <a href="javascript:;" @click="select(item.value)">{{item.text}}</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['model', 'attribute', 'label', 'type', 'rightMenu', 'options', 'icon'],
  data() {
    return {inputVal: this.model[this.attribute] ? this.model[this.attribute] : null}
  },
  computed: {
    btnClass() {
      if (this.type === 'bordered') {
        return "btn btn-outline-gray btn-sm is-border-1 dropdown-toggle";
      }
      return "btn dropdown-toggle";
    },
    selected() {
      let selected = this.options.find(i => i.value === this.inputVal);
      if (selected) {
        return selected.text;
      } else if(this.options.length > 0) {
        return this.options[0].text;
      }
      return null;
    }
  },
  watch: {
    model: {
      handler(val) {
        this.inputVal = val[this.attribute];
      }, deep: true
    },
  },
  methods: {
    select(value) {
      this.inputVal = value;
      this.model[this.attribute] = value;
      this.$emit('change');
    }
  }
}
</script>